import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { TagsServiceProvider } from '../../api/tags'

const TagsService = TagsServiceProvider()
const name = 'updateTag'

export default (data) => (asyncAction(
  name,
  TagsService.updateTag,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/tags/updateTag.js